import { render } from "./GlobalAboutListSingle.vue?vue&type=template&id=2e8a701f"
import script from "./GlobalAboutListSingle.vue?vue&type=script&lang=js"
export * from "./GlobalAboutListSingle.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__